// components/whatsapp-button.tsx
"use client";

import { a } from "framer-motion/client";

const WHATSAPP_NUMBER = "94772090344"; // replace with your number, no + or leading 0
const WHATSAPP_MESSAGE = "Hi! I'd like to know more about LilyLanka.";

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-[94px] left-6 z-[9997] flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] shadow-lg transition-transform hover:scale-105 active:scale-95"
    >
      <svg
        viewBox="0 0 24 24"
        className="h-8 w-8 fill-white"
        aria-hidden="true"
      >
        <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm5.78 14.01c-.25.7-1.45 1.34-2 1.42-.51.08-1.15.11-1.86-.12-.43-.13-.98-.31-1.69-.6-2.97-1.28-4.9-4.27-5.05-4.47-.15-.2-1.21-1.6-1.21-3.05s.76-2.17 1.03-2.47c.27-.3.59-.37.79-.37.2 0 .39.002.56.01.18.01.42-.07.66.5.25.6.84 2.05.91 2.2.07.15.12.33.02.53-.1.2-.15.33-.3.5-.15.18-.31.4-.45.54-.15.15-.3.31-.13.61.18.3.79 1.3 1.69 2.1 1.16 1.04 2.14 1.37 2.45 1.52.31.15.49.13.67-.07.18-.2.78-.91.99-1.22.2-.31.41-.26.69-.16.27.1 1.74.82 2.04.97.3.15.5.22.57.35.07.13.07.74-.18 1.45z" />
      </svg>
    </a>
  );
}
